(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pricing"]) return;
  try {
    
  async function replacePricing() {
  let cta = '_cta3';
  const resp = await fetch(`/products/${window.customer.hairRecos.handle}-with-conditioner?view=${cta}`);
  const data = await resp.text();
  setHTMLAndExecuteJS(document.querySelector(".static"), data);
  }
function setHTMLAndExecuteJS(elm, html) {
  elm.innerHTML = html;
  Array.from(elm.querySelectorAll("script")).forEach(oldScript => {
    const newScript = document.createElement("script");
    Array.from(oldScript.attributes)
      .forEach(attr => newScript.setAttribute(attr.name, attr.value));
    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}
(async function() {
  if(window.hairRecosReady) {
    await replacePricing();
  } else {
    document.addEventListener("hairRecosReady", async function () {
      await replacePricing();
    });
  }
  const pricing_Plans = document.querySelectorAll(".pricingPlan");
  if(pricing_Plans) {
    pricing_Plans.forEach(p => p.addEventListener("click", function () {
      pricing_Plans.forEach(q => {
      q.classList.remove("border-primary");
      q.classList.add("border-[#DDDDDD]");
        if(q === p) {
          q.classList.add("border-primary");
          q.classList.remove("border-[#DDDDDD]");
        }
      });
    }));
  }
})();

  } catch(e) { console.error(e); }
})();
})();
